import psl from 'psl';
import { format, isValid, parse } from "date-fns";
import { isMobile, isTablet } from "react-device-detect";
import { toast } from "react-toastify";
import QRCode from "qrcode";
import CONSTANT from "../constants/Constant";
import GLOBAL from "../global";
import storageService from "./StorageService";
import examService from "../services/ExamService";
import exerciseService from "../services/ExerciseService";
import answerValidationMessagesConstant from "../services/answerValidation/answerValidationMessagesConstant";
import audioManager from "./AudioManager";

// export const playAudio = (url) => {
//     return new Promise((resolve) => {
//         try {
//             if (!url) {
//                 resolve();
//                 return;
//             }
//
//             const audioLength = document.getElementsByTagName("audio").length;
//             if (audioLength > 0) {
//                 const previousAudio = document.getElementsByTagName("audio")[0];
//                 previousAudio.pause();
//                 previousAudio.remove();
//             }
//
//             function removeAudioAndResolve() {
//                 audio.remove();
//                 resolve('Audio removed manually');
//             }
//
//
//             if (url === 'remove') {
//                 const audioElements = document.getElementsByTagName("audio");
//                 if (audioElements.length > 0) {
//                     const previousAudio = audioElements[0];
//                     previousAudio.pause();
//                 } else {
//                     resolve('No audio to remove');
//                 }
//                 return;
//             }
//
//             if (!GLOBAL.AUDIO_PLAY_ENABLED) {
//                 resolve('audio is disabled');
//                 return;
//             }
//
//             const audio = document.createElement('audio');
//             audio.style.height = "0px";
//             audio.style.width = "0px";
//
//             url = url + "?t=" + new Date().getTime();
//             audio.setAttribute('src', url);
//             document.body.append(audio);
//
//             audio.load();
//             audio.muted = false;
//             audio.currentTime = 0;
//             audio.autoplay = false;
//
//             audio.addEventListener('pause', function() {
//                 if (audio.paused && !audio.ended) {
//                     removeAudioAndResolve();
//                 }
//             });
//
//             audio.onended = function () {
//                 audio.remove(); //Remove when played.
//                 resolve('Audio has been played');
//             };
//
//             const playPromise = audio.play();
//             if (playPromise !== undefined) {
//                 playPromise.then(function () {
//                     // Automatic playback started!
//                 }).catch(function () {
//                     resolve("Audio is missed");
//                     // Automatic playback failed.
//                     // Show a UI element to let the user manually start playback.
//                 });
//             }
//
//         } catch (error) {
//             resolve("Audio is missed");
//         }
//     });
// };


// A small wrapper around the Web Audio API to mimic your original function.
// Notes:
// 1. "Pause" is approximated by stopping the source in the Web Audio API.
// 2. There's no built-in pause event on a BufferSource like <audio> has.
// 3. If you need repeated playback or actual pausing/resuming, you'd have to
//    store playback offsets and recreate the source. That is more advanced
//    than this minimal replication.

// Keep these references in module scope (or at least
// somewhere they persist between calls).
// let audioContext = null;
// let currentSource = null;
// let fetchController = null;
//
// export const playAudio = (url) => {
//     return new Promise((resolve) => {
//         console.error("playAudioWebAPI:", url);
//
//         // 1. Handle special cases
//         if (!url) {
//             console.error('No URL provided.');
//             resolve("No URL provided.");
//             return;
//         }
//
//         // If you have a global flag disabling audio
//         // if (!GLOBAL.AUDIO_PLAY_ENABLED) {
//         //     console.error("Audio is disabled globally.");
//         //     resolve("Audio is disabled globally.");
//         //     return;
//         // }
//
//         // If the caller wants to 'remove' existing audio
//         if (url === "remove") {
//             console.log('inside remove');
//             if (currentSource) {
//                 try {
//                     console.log('inside remove try has currentSource');
//                     currentSource.stop(0);
//                 } catch (e) {
//                     console.warn("Stopping source error:", e);
//                 }
//                 currentSource = null;
//             }
//             if (audioContext) {
//                 console.log('inside remove has audioContext');
//                 audioContext.close().catch((err) => {
//                     console.warn("Closing audioContext error:", err);
//                 });
//                 audioContext = null;
//             }
//             resolve("Audio removed manually.");
//             return;
//         }
//
//         // 2. Stop / abort any currently fetching or playing audio immediately
//         if (fetchController) {
//             console.error('inside fetchController abortting it as have to play new audio');
//             // Abort a pending fetch so it never completes decoding:
//             fetchController.abort();
//             // fetchController = null;
//         }
//         if (currentSource) {
//             try {
//                 console.error('inside currentSource stopping it as have to play new audio');
//                 currentSource.stop();
//             } catch (e) {
//                 console.error("Stopping current source error:", e);
//             }
//             currentSource = null;
//         }
//         if (audioContext) {
//             console.error('inside audioContext closing it as have to play new audio');
//             audioContext.close().catch((err) => {
//                 console.error("Closing audioContext error:", err);
//             });
//             audioContext = null;
//         }
//
//         // 3. Create a fresh AudioContext
//         audioContext = new AudioContext();
//         console.error('created new audioContext');
//
//         // 4. Create a new AbortController for the new fetch
//         fetchController = new AbortController();
//         console.error('created new fetchController');
//
//         // Append a timestamp to help avoid caching issues
//         const fetchUrl = url + "?t=" + new Date().getTime();
//
//         // 5. Start fetching and decoding with the Web Audio API
//         fetch(fetchUrl, { signal: fetchController.signal })
//             .then((res) => {
//                 console.error("successfully fetched audio");
//                 if (!res.ok) {
//                     throw new Error("Network response was not ok.");
//                 }
//                 return res.arrayBuffer();
//             })
//             .then((arrayBuffer) => {
//
//                 console.error("successfully fetched arrayBuffer");
//                 // If the fetch was aborted, this might throw,
//                 // or we might skip decoding. We'll rely on catch() to handle.
//                 return audioContext.decodeAudioData(arrayBuffer);
//             })
//             .then((audioBuffer) => {
//                 // Only proceed if we haven't been replaced by a new call:
//                 if (!audioContext) {
//                     // This means something else closed or replaced the context
//                     throw new Error("AudioContext no longer valid (aborted/closed).");
//                 }
//
//                 console.error("successfully decoded audioBuffer");
//                 console.error("Creating buffer source ");
//                 // 6. Create a new BufferSource and start playback
//                 currentSource = audioContext.createBufferSource();
//                 currentSource.buffer = audioBuffer;
//                 console.error("Buffer source created");
//                 currentSource.connect(audioContext.destination);
//
//                 currentSource.onended = () => {
//                     console.error("Audio playback ended.");
//                     // Clean up references once playback ends
//                     currentSource = null;
//                     // Close context if you'd like, or leave it open if you keep playing more...
//                     if (audioContext) {
//                         console.error("Closing audioContext");
//                         audioContext
//                             .close()
//                             .catch((e) => console.error("AudioContext close error:", e))
//                             .finally(() => (audioContext = null));
//                     }
//                     resolve("Audio finished playing.");
//                 };
//
//                 // Attempt to start playback
//                 try {
//                     console.error("Starting audio playback");
//                     currentSource.start(0);
//                 } catch (startError) {
//                     console.error("Audio start failed:", startError);
//                     resolve("Audio start failed.");
//                 }
//             })
//             .catch((err) => {
//                 if (err.name === "AbortError") {
//                     // This is an expected "fetch aborted" situation
//                     console.error("Fetch aborted, skipping audio playback.");
//                     resolve("Audio aborted due to a new request.");
//                 } else {
//                     console.error("Fetching or decoding audio failed:", err);
//                     resolve("Audio is missed or failed to decode.");
//                 }
//             });
//     });
// };


// We keep these in module/global scope so that repeated playAudio() calls
// share one AudioContext, a single "unlock" flow, etc.

// The shared AudioContext we’ll use for decoding + playback:
let audioContext = null;

// The current source node so we can stop it when new audio is requested:
let currentSource = null;

// The current fetch AbortController (to abort if a new request arrives):
let fetchController = null;

// Has Safari/iOS been "unlocked" yet?
let isUnlocked = false;

/**
 * 1) Create (or reuse) an AudioContext.
 * 2) Set up the "unlock" logic on iOS Safari if not already done.
 */
function initAudioSystem() {
    if (!audioContext) {
        // Create the AudioContext. (Use webkit prefix if needed for older Safari.)
        audioContext = new (window.AudioContext || window.webkitAudioContext)();

        // Attempt to unlock once in a user interaction (click/touch) if needed.
        // If we've already unlocked, or the browser doesn't require it, that's fine.
        setupAudioUnlock(audioContext);
    }
}

/**
 * Set up an event listener that "unlocks" the AudioContext on the first user gesture.
 * After unlocking, remove these listeners so we don’t do it repeatedly.
 */
function setupAudioUnlock(ctx) {
    // If we’re already unlocked or context not in "suspended" state, skip.
    if (isUnlocked || !ctx || ctx.state !== "suspended") return;

    // The routine that actually resumes (unlocks) the context:
    function unlock() {
        // Resume the context, which is enough for most modern Safari + iOS.
        ctx.resume().then(() => {
            if (ctx.state === "running") {
                isUnlocked = true;
                removeUnlockListeners();
            }
        });
    }

    // Attach the unlock attempt to a few user actions:
    function removeUnlockListeners() {
        document.removeEventListener("touchstart", unlock);
        document.removeEventListener("touchend", unlock);
        document.removeEventListener("mousedown", unlock);
        document.removeEventListener("keydown", unlock);
    }
    document.addEventListener("touchstart", unlock, false);
    document.addEventListener("touchend", unlock, false);
    document.addEventListener("mousedown", unlock, false);
    document.addEventListener("keydown", unlock, false);
}

/**
 * Main function to play or remove audio.
 * @param {string} url - Audio URL. Pass "remove" to stop/remove current audio.
 * @return {Promise<string>} Resolves on finished playback or removal; rejects on error.
 */
// export function playAudio(url) {
//     return new Promise((resolve, reject) => {
//         // Handle "remove" special case:
//         if (url === "remove") {
//             stopCurrentAudio();
//             return resolve("Audio removed manually.");
//         }
//
//         // If no URL, just resolve.
//         if (!url) {
//             return resolve("No URL provided.");
//         }
//
//         if (!GLOBAL.AUDIO_PLAY_ENABLED) {
//             resolve("Audio is disabled globally.");
//             return;
//         }
//
//         // Make sure we have an AudioContext & set up unlocking
//         initAudioSystem();
//
//         // Stop/abort any currently fetching or playing audio
//         if (fetchController) {
//             fetchController.abort();
//             fetchController = null;
//         }
//         stopCurrentAudio(); // stops old source if playing
//
//         // Start a new AbortController for the new fetch
//         fetchController = new AbortController();
//         const { signal } = fetchController;
//
//         // We add a query param to avoid browser caching issues
//         const fetchUrl = url + "?t=" + Date.now();
//
//         // Fetch + decode, then play
//         fetch(fetchUrl, { signal })
//             .then((response) => {
//                 if (!response.ok) {
//                     throw new Error(`Network response was not ok: ${response.status}`);
//                 }
//                 return response.arrayBuffer();
//             })
//             .then((arrayBuf) => audioContext.decodeAudioData(arrayBuf))
//             .then((audioBuffer) => {
//                 // If the fetch was aborted or the context was closed, bail out:
//                 if (!audioContext || audioContext.state === "closed") {
//                     throw new Error("AudioContext no longer valid (aborted/closed).");
//                 }
//
//                 // Create a fresh BufferSource and hook it up
//                 currentSource = audioContext.createBufferSource();
//                 currentSource.buffer = audioBuffer;
//                 currentSource.connect(audioContext.destination);
//
//                 // On ended, clean up + resolve
//                 currentSource.onended = () => {
//                     currentSource = null;
//                     resolve("Audio finished playing.");
//                 };
//
//                 // Attempt to play
//                 // Safari might still be "locked" if no user gesture has ever happened.
//                 // If the context is suspended, try to resume once. If that fails, the
//                 // user hasn't interacted yet, so it won't play. You can handle that case if desired.
//                 if (audioContext.state === "suspended") {
//                     audioContext.resume().then(() => {
//                         currentSource.start(0);
//                     }).catch((resumeErr) => {
//                         console.warn("AudioContext resume failed:", resumeErr);
//                         reject("Failed to resume AudioContext (likely no user gesture yet).");
//                     });
//                 } else {
//                     // context is running
//                     currentSource.start(0);
//                 }
//             })
//             .catch((err) => {
//                 if (err.name === "AbortError") {
//                     console.error("Fetch aborted (new audio requested).");
//                     resolve("Audio aborted due to a new request.");
//                 } else {
//                     console.error("Error fetching/decoding/playing audio:", err);
//                     reject(err.message || err.toString());
//                 }
//             });
//     });
// }

// A unique identifier for the current audio request
let currentRequestId = 0;

// Queue management for queue mode
let audioQueue = [];
let isProcessingQueue = false;

// Force-stop epoch: increments on forceStopAllAudio, playAudioWithRetry captures
// current epoch at start — if epoch changed during retry loop, old invocation bails
let forceStopEpoch = 0;

// Audio buffer cache — avoids re-downloading same audio within session
const audioBufferCache = new Map();

/**
 * Play audio with optional queue support
 *
 * @param {string} url - Audio URL or "remove" to stop playback
 * @param {Object} options - Playback options
 * @param {boolean} options.queue - Enable queue mode for sequential playback (default: false)
 * @param {boolean} options.skipDuplicates - Skip if same URL already queued/playing (default: false)
 * @returns {Promise<string>} Resolves when playback completes
 */
export function playAudio(url, options = {}) {
    const { queue = false, skipDuplicates = false } = options;

    // If queue mode is enabled, add to queue instead of playing immediately
    if (queue && url !== "remove") {
        return addToQueue(url, skipDuplicates);
    }

    // -------- MAIN PLAYBACK --------
    return new Promise((resolve, reject) => {

        // Manual stop / reset
        if (url === "remove") {
            stopCurrentAudio();
            clearAudioQueue();
            audioManager.reset();

            return resolve("Audio removed manually.");
        }

        if (!url) {
            return resolve("No URL provided.");
        }

        if (!GLOBAL.AUDIO_PLAY_ENABLED) {
            console.log('🔇 Audio is disabled globally - skipping playback for:', url);
            return resolve("Audio is disabled globally.");
        }

        playAudioInternal(url)
            .then((result) => {
                resolve(result);
                processQueue();
            })
            .catch(reject);
    });
}

/**
 * Play audio with automatic retry when aborted by concurrent playAudio calls.
 * React re-renders can abort in-flight audio fetches; this retries until it succeeds.
 * @param {string} audioUrl
 * @param {object} options - playAudio options (queue, etc.)
 * @param {number} maxRetries
 * @param {number} retryDelay - ms between retries
 * @returns {Promise<string>} playAudio result string
 */
export async function playAudioWithRetry(audioUrl, options = {}, maxRetries = 10, retryDelay = 200) {
    // Capture current epoch — if forceStopAllAudio fires during retries,
    // epoch changes and this invocation bails (new invocation has new epoch)
    const startEpoch = forceStopEpoch;

    let playResult = null;
    let retries = 0;

    while (retries < maxRetries) {
        if (forceStopEpoch !== startEpoch) {
            console.log(`[AUDIO-RETRY] BAIL — epoch changed. start: ${startEpoch}, current: ${forceStopEpoch}`);
            return "Audio force-stopped.";
        }

        playResult = await playAudio(audioUrl, options);

        if (playResult === "Audio request aborted.") {
            if (forceStopEpoch !== startEpoch) {
                console.log(`[AUDIO-RETRY] BAIL on abort — epoch changed. start: ${startEpoch}, current: ${forceStopEpoch}`);
                return "Audio force-stopped.";
            }
            retries++;
            if (retries < maxRetries) {
                await new Promise(r => setTimeout(r, retryDelay));
            }
            continue;
        }
        break;
    }

    if (retries > 0) {
        console.log(`[AUDIO-RETRY] ${playResult === "Audio finished playing." ? 'succeeded' : 'failed'} after ${retries + 1} attempts`);
    }

    return playResult;
}

/**
 * Force-stop all audio playback and prevent retries.
 * Called during component cleanup (Save & Close, unmount).
 */
export function forceStopAllAudio() {
    console.log(`[AUDIO] FORCE STOP — epoch: ${forceStopEpoch} → ${forceStopEpoch + 1}`);
    forceStopEpoch++;
    stopCurrentAudio();
    clearAudioQueue();
    audioManager.reset();
}

// Modified stopCurrentAudio - only used for explicit stopping
function stopCurrentAudio() {
    // Increment the request ID to invalidate any in-progress requests
    currentRequestId++;

    if (currentSource) {
        try {
            console.log(`[AUDIO] STOP source — requestId: ${currentSource.requestId}, epoch: ${forceStopEpoch}`);
            currentSource.stop(0);
        } catch (e) {
            console.warn("Error stopping current source:", e);
        }
        currentSource = null;
    }

    // Abort any in-progress fetch
    if (fetchController) {
        fetchController.abort();
        fetchController = null;
    }

    // Reset AudioManager state when stopping
    audioManager.reset();
}

/**
 * Add audio URL to queue for sequential playback
 * @param {string} url - Audio URL to queue
 * @param {boolean} skipDuplicates - Skip if URL already in queue or playing
 * @returns {Promise<string>} Resolves when this audio finishes playing
 */
function addToQueue(url, skipDuplicates) {
    return new Promise((resolve) => {
        // Check for duplicates if requested
        if (skipDuplicates) {
            // Check if currently playing
            if (audioManager.getCurrentAudioUrl() === url) {
                // console.log('🔇 Skipping duplicate audio (already playing):', url);
                return resolve("Duplicate audio skipped - already playing.");
            }

            // Check if already in queue
            const isDuplicate = audioQueue.some(item => item.url === url);
            if (isDuplicate) {
                // console.log('🔇 Skipping duplicate audio (already queued):', url);
                return resolve("Duplicate audio skipped - already in queue.");
            }
        }

        // Add to queue
        audioQueue.push({ url, resolve });
        // console.log(`📝 Added to audio queue (${audioQueue.length} items):`, url);

        // Start processing if not already processing
        if (!isProcessingQueue) {
            processQueue();
        }
    });
}

/**
 * Process the audio queue sequentially
 */
function processQueue() {
    // If already processing or queue is empty, return
    if (isProcessingQueue || audioQueue.length === 0) {
        return;
    }

    // Check if another audio is currently playing (from non-queue mode)
    if (audioManager.getIsPlaying()) {
        // console.log('🔇 Queue paused - another audio is playing');
        // Clear queue since we ignore audio when another is playing
        audioQueue = [];
        isProcessingQueue = false;
        return;
    }

    isProcessingQueue = true;

    // Get next item from queue
    const nextItem = audioQueue.shift();
    // console.log(`▶️ Processing queued audio (${audioQueue.length} remaining):`, nextItem.url);

    // Play the audio (using the internal implementation, not queue mode)
    playAudioInternal(nextItem.url)
        .then((result) => {
            nextItem.resolve(result);
            isProcessingQueue = false;
            // Process next item if any
            processQueue();
        })
        .catch((err) => {
            console.error('Queue audio playback error:', err);
            nextItem.resolve(`Queue audio failed: ${err}`);
            isProcessingQueue = false;
            // Continue with next item
            processQueue();
        });
}

/**
 * Clear all queued audio
 */
function clearAudioQueue() {
    if (audioQueue.length > 0) {
        // console.log(`🗑️ Clearing audio queue (${audioQueue.length} items)`);
        // Resolve all pending promises
        audioQueue.forEach(item => item.resolve("Audio queue cleared."));
        audioQueue = [];
    }
    isProcessingQueue = false;
}

/**
 * Internal audio playback (called by both direct and queue mode)
 * This is the actual implementation without queue logic
 * @param {string} url - Audio URL
 * @param {boolean} isPriority - Whether this is priority audio
 */
function playAudioInternal(url) {
    // Capture epoch at call time — if forceStopAllAudio fires before
    // this request's decode completes, the epoch check will prevent playback
    const capturedEpoch = forceStopEpoch;

    return new Promise((resolve, reject) => {
        // If no URL, just resolve.
        if (!url) {
            return resolve("No URL provided.");
        }

        if (!GLOBAL.AUDIO_PLAY_ENABLED) {
            // console.log('🔇 Audio is disabled globally - skipping playback for:', url);
            resolve("Audio is disabled globally.");
            return;
        }

        // Note: No blocking check here - processQueue() handles overlap prevention for queue mode
        // Direct mode audio will naturally replace any currently playing audio

        // First, stop any currently playing audio WITHOUT incrementing the ID yet
        if (currentSource) {
            try {
                currentSource.stop(0);
            } catch (e) {
                console.warn("Error stopping current source:", e);
            }
            currentSource = null;
        }

        // Abort any in-progress fetch
        if (fetchController) {
            fetchController.abort();
            fetchController = null;
        }

        // NOW increment the ID for this new request
        const thisRequestId = ++currentRequestId;

        // Make sure we have an AudioContext & set up unlocking
        initAudioSystem();

        // Create a new AbortController for this request
        fetchController = new AbortController();
        const { signal } = fetchController;

        // We add a query param to avoid browser caching issues
        // const fetchUrl = url + "?t=" + Date.now();
        const fetchUrl = url;

        // Check cache first — skip fetch+decode if already buffered
        const cached = audioBufferCache.get(fetchUrl);
        let decodePromise;

        if (cached) {
            console.log(`[AUDIO] CACHE HIT — using cached buffer for: ${fetchUrl}, epoch: ${capturedEpoch}, requestId: ${thisRequestId}`);
            decodePromise = Promise.resolve(cached);
        } else {
            console.log(`[AUDIO] CACHE MISS — fetching: ${fetchUrl}, epoch: ${capturedEpoch}, requestId: ${thisRequestId}`);
            // Fetch + decode, then cache
            decodePromise = fetch(fetchUrl, { signal })
                .then((response) => {
                    if (thisRequestId !== currentRequestId) {
                        throw new AbortError("Request no longer current");
                    }

                    if (!response.ok) {
                        throw new Error(`Network response was not ok: ${response.status}`);
                    }
                    return response.arrayBuffer();
                })
                .then((arrayBuf) => {
                    if (thisRequestId !== currentRequestId) {
                        throw new AbortError("Request no longer current");
                    }

                    return audioContext.decodeAudioData(arrayBuf);
                })
                .then((audioBuffer) => {
                    // Cache the decoded buffer for future plays
                    audioBufferCache.set(fetchUrl, audioBuffer);
                    return audioBuffer;
                });
        }

        decodePromise.then((audioBuffer) => {
            // Final check if this is still the active request
            if (thisRequestId !== currentRequestId) {
                throw new AbortError("Request no longer current");
            }

            // Check if audio was force-stopped during decode (cached audio resolves fast)
            if (forceStopEpoch !== capturedEpoch) {
                console.log(`[AUDIO] BLOCKED — epoch changed during decode. captured: ${capturedEpoch}, current: ${forceStopEpoch}, url: ${fetchUrl}`);
                resolve("Audio force-stopped.");
                return;
            }

            if (!audioContext || audioContext.state === "closed") {
                throw new Error("AudioContext no longer valid (closed).");
            }

            // Create a fresh BufferSource and hook it up
            currentSource = audioContext.createBufferSource();
            currentSource.buffer = audioBuffer;
            currentSource.connect(audioContext.destination);

            // Store the request ID this source is associated with
            currentSource.requestId = thisRequestId;

            // Set AudioManager state to playing
            audioManager.setPlaying(true, fetchUrl);

            // Capture source in local variable so onended closure still works
            // after stopCurrentAudio() sets currentSource = null
            const thisSource = currentSource;

            // On ended, clean up + resolve
            thisSource.onended = () => {
                // Only null currentSource if it still points to THIS source.
                // A new playAudioInternal call may have replaced currentSource
                // with a newer source — we must not null it from a stale onended.
                if (currentSource === thisSource) {
                    currentSource = null;
                    // Reset AudioManager state when audio ends
                    audioManager.reset();
                }
                console.log(`[AUDIO] ENDED naturally — url: ${fetchUrl}, requestId: ${thisRequestId}`);
                resolve("Audio finished playing.");

                // Note: processQueue() is NOT called here for internal function
                // It's only called from the main playAudio function's onended
            };

            // Attempt to play
            if (audioContext.state === "suspended") {
                audioContext.resume().then(() => {
                    // One final check before playing
                    if (thisRequestId === currentRequestId && currentSource) {
                        console.log(`[AUDIO] START (resumed ctx) — url: ${fetchUrl}, requestId: ${thisRequestId}, cached: ${!!audioBufferCache.get(fetchUrl)}`);
                        currentSource.start(0);
                    } else {
                        console.log(`Not starting audio - request ${thisRequestId} no longer current`);
                    }
                }).catch((resumeErr) => {
                    console.warn("AudioContext resume failed:", resumeErr);
                    reject(new Error("Failed to resume AudioContext (likely no user gesture yet)."));
                });
            } else {
                // One final check before playing
                if (thisRequestId === currentRequestId) {
                    console.log(`[AUDIO] START — url: ${fetchUrl}, requestId: ${thisRequestId}, cached: ${!!audioBufferCache.get(fetchUrl)}`);
                    currentSource.start(0);
                } else {
                    console.log(`Not starting audio - request ${thisRequestId} no longer current`);
                }
            }
        }).catch((err) => {
            // Reset AudioManager state on error or abort
            audioManager.reset();

            if (err.name === "AbortError" || err instanceof AbortError) {
                resolve("Audio request aborted.");
            } else {
                console.error(`Error for request ${thisRequestId}:`, err);
                reject(err.message || err.toString());
            }
        });
    });
}

// Add this helper class
class AbortError extends Error {
    constructor(message) {
        super(message);
        this.name = "AbortError";
    }
}

export const getMarkup = (text) => {
    return { __html: text };
};

export const replaceCharactersWithAsterisk = (text) => {
    return text.replace(/./g, "*");
};

export const calculateAge = (dateOfBirth) => {
    // CASE 1: MM/YYYY → convert to MM/01/YYYY
    if (/^(0?[1-9]|1[0-2])\/\d{4}$/.test(dateOfBirth)) {
        const [month, year] = dateOfBirth.split("/");
        dateOfBirth = `${month}/01/${year}`;
    }

    // Now parse the final date
    const dob = new Date(dateOfBirth);

    if (isNaN(dob.getTime())) {
        return null; // or throw error
    }

    const today = new Date();
    let age = today.getFullYear() - dob.getFullYear();

    const hasNotHadBirthdayThisYear =
        today.getMonth() < dob.getMonth() ||
        (today.getMonth() === dob.getMonth() &&
            today.getDate() < dob.getDate());

    if (hasNotHadBirthdayThisYear) {
        age--;
    }

    return age;
};

export const dateInPast = (date) => {
    const today = new Date();

    const userDate = date.split('/');
    const formatedDate = new Date(`${userDate[2]}-${userDate[0]}-${userDate[1]}`);

    today.setHours(0, 0, 0, 0);

    return formatedDate < today;

};

export const getSubdomain = () => {
    const parsed = psl.parse(window.location.hostname);
    return parsed && parsed.subdomain;
};

export const isNSCSubdomain = () => {
    return GLOBAL.USER_INFO?.Permissions?.IsSpinealignEnabled === true;
}

export const formatDate = (date, formatString = CONSTANT.DATE_FORMAT.MM_DD_YYYY) => {
    return format(date, formatString);
};
export const formatDatetime = (date) => {
    return format(date, CONSTANT.DATE_FORMAT.MM_DD_YYYY_HH_MM);
};

export const capitalizeFirstLetter = (value) => {
    if (!value) return '';

    return value.charAt(0).toUpperCase() + value.slice(1);
}

export const roundToNearestMinutes = (dateTime, nearest = 5) => {
    const coefficient = 1000 * 60 * nearest;
    const date = dateTime || new Date();  //or use any other date

    return new Date(Math.round(date.getTime() / coefficient) * coefficient);
};

export const convertToBase64 = (file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onerror = reject;
        reader.onloadend = function () {
            resolve(reader.result);
        }
        reader.readAsDataURL(file);
    });
};

export const convertToF = (celsius) => {
    return (celsius * 9 / 5 + 32).toFixed(2);
};

export const kphToMph = (speed) => {
    return (speed * 0.62).toFixed(2);
};

export const checkCameraAvailability = (userMediaError) => {
    if (userMediaError) {
        navigator.mediaDevices.getUserMedia({ video: true })
            .catch(e => {
                if (e.toString() === 'NotReadableError: Could not start video source') {
                    if (isMobile || isTablet) {
                        toast.dark('Video isn\'t working. We could not use your camera');
                    } else {
                        toast.dark('Video isn\'t working. We could not use your webcam');
                    }
                }
            });
    }
}

export const getOrdinalSuffixes = (day) => {
    let ordinalSuffixes = "th"
    if(+day === 1) ordinalSuffixes = "st"
    else if(+day === 2) ordinalSuffixes = "nd"
    else if(+day === 3) ordinalSuffixes = "rd"

    return ordinalSuffixes
}

export const formateDate = (date) => {
    date = new Date(date).toISOString().split('T')[0]
    const dateArr = date.split('-');

    return `${dateArr.length >=3 && `${dateArr[2]}${getOrdinalSuffixes(dateArr[2])} ${CONSTANT.MONTHS[parseInt(dateArr[1])-1]}`} `
}

export const getDateFormat = (date, dayFirst = false) => {
    let selectedDate = new Date(date.getTime());
    const year = selectedDate.getFullYear();
    const month = ("0" + (date.getMonth() + 1)).slice(-2);
    const day = ("0" + date.getDate()).slice(-2);

    if(dayFirst) {
        return [day, month, year].join("/");
    }
    else {
        return [month, day, year].join("/");
    }
};

export const swapDayWithMonthOfDate = (date) => {
    if(!date) return;

    const inputDateString = date;
    const parts = inputDateString.split("/");
    const day = parts[1];
    const month = parts[0];
    const year = parts[2];

    return`${day}/${month}/${year}`;
}

const range = (start, end) => {
    const ans = [];
    for (let i = start; i < end; i++) {
        ans.push(i);
    }

    return ans;
};

export const years = range(1900, new Date().getFullYear() + 1, 1);

function propComparator(propertyName) {
    return function (a, b) {
        return a[propertyName] > b[propertyName] ? 1 : -1;
    }
}

export const sortBy = (arrayList = [], propertyName) => {
    return arrayList.sort(propComparator(propertyName));
};

export const getUrlParameterByName = (name) => {
    const url = window.location.href;
    name = name.replace(/[[\]]/g, "\\$&");
    name = name.toLowerCase();

    const regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)");
    const results = regex.exec(url.toLowerCase());

    if (!results) return '';
    if (!results[2]) return '';

    return decodeURIComponent(results[2].replace(/\+/g, " "));
};

export const getUserIdentification = () => {
    let loginHeaderText;

    if (storageService.getItem('providerLogin') === 'true') {
        loginHeaderText = 'Provider';
    } else {
        loginHeaderText = 'User';
    }

    return loginHeaderText;
}

const checkLeapYear = (year) => {
    if (((0 === year % 4) && (0 !== year % 100)) || (0 === year % 400)) {
        return true;
    }

    return false;
}

const dayValidation = (month, day, year) => {
    const monthThirtyOne = [1, 3, 5, 7, 8, 10, 12]; // Months with 31 days
    const parsedMonth = parseInt(month);
    const parsedDay = parseInt(day);
    const parsedYear = parseInt(year);

    // February handling
    if (parsedMonth === 2) {
        const maxDay = checkLeapYear(parsedYear) ? 29 : 28;
        return parsedDay >= 1 && parsedDay <= maxDay;
    }

    // Months with 31 days
    if (monthThirtyOne.includes(parsedMonth)) {
        return parsedDay >= 1 && parsedDay <= 31;
    }

    // All other months (which have 30 days)
    return parsedDay >= 1 && parsedDay <= 30;
};

export const dateValidator = (message) => {
    let valid = true;
    let validationMessage = "";
    const number = /^[0-9]+$/;
    const url = window.location.href;
    const isSignUp = url.includes('/sign-up') || url.includes('/new-registration');

    // -----------------------------
    // CASE 1: MM/YYYY (No day)
    // -----------------------------
    if (/^(0?[1-9]|1[0-2])\/\d{4}$/.test(message)) {
        const [month, year] = message.split("/");

        if (year.length !== 4) {
            return {
                valid: false,
                message:
                answerValidationMessagesConstant.DATE.INVALID_YEAR_LESS_THAN_FOUR_DIGIT
            };
        }

        if (!year.match(number)) {
            return {
                valid: false,
                message:
                answerValidationMessagesConstant.DATE.INVALID_YEAR_NOT_DIGIT
            };
        }

        if (parseInt(year, 10) < 1000) {
            return {
                valid: false,
                message: isSignUp ? answerValidationMessagesConstant.DATE.INVALID_2 : answerValidationMessagesConstant.DATE.INVALID
            };
        }

        return { valid: true, message: "" };
    }

    // -----------------------------
    // CASE 2: MM/DD/YYYY
    // -----------------------------
    if (
        /^(0?[1-9]|1[0-2])\/(0?[1-9]|[12]\d|3[01])\/\d{4}$/.test(message)
    ) {
        const [month, day, year] = message.split("/");

        // Validate real date
        const validDate = isValid(new Date(`${month}/${day}/${year}`));

        if (!validDate) {
            return {
                valid: false,
                message: isSignUp ? answerValidationMessagesConstant.DATE.INVALID_2 : answerValidationMessagesConstant.DATE.INVALID
            };
        }

        // Validate days per month (your custom logic)
        if (!dayValidation(month, day, year)) {
            return {
                valid: false,
                message: isSignUp ? answerValidationMessagesConstant.DATE.INVALID_2 : answerValidationMessagesConstant.DATE.INVALID
            };
        }

        if (year.length !== 4) {
            return {
                valid: false,
                message:
                    answerValidationMessagesConstant.DATE.INVALID_YEAR_LESS_THAN_FOUR_DIGIT
            };
        }

        if (!year.match(number)) {
            return {
                valid: false,
                message:
                    answerValidationMessagesConstant.DATE.INVALID_YEAR_NOT_DIGIT
            };
        }

        if (parseInt(year, 10) < 1000) {
            return {
                valid: false,
                message: isSignUp ? answerValidationMessagesConstant.DATE.INVALID_2 : answerValidationMessagesConstant.DATE.INVALID
            };
        }

        return { valid: true, message: "" };
    }

    // -----------------------------
    // INVALID FORMAT
    // -----------------------------

    // Check for specific errors if format is roughly correct (e.g. has slashes)
    const splitDate = message.split('/');
    if (splitDate.length >= 2) {
        const monthStr = splitDate[0];
        // Clean year (last part) of mask chars/underscores
        const yearStr = splitDate[splitDate.length - 1].replace(/[^0-9]/g, '');

        // Check Month
        if (/^\d+$/.test(monthStr)) {
            const monthInt = parseInt(monthStr, 10);
            if (monthInt < 1 || monthInt > 12) {
                return {
                    valid: false,
                    message: answerValidationMessagesConstant.DATE.INVALID_MONTH
                };
            }
        }

        // Check Year Length (if present)
        if (yearStr.length > 0 && (yearStr.length < 4 || parseInt(yearStr, 10) < 1000)) {
            return {
                valid: false,
                message: answerValidationMessagesConstant.DATE.INVALID_YEAR_LESS_THAN_FOUR_DIGIT
            };
        }
    }

    return {
        valid: false,
        message: isSignUp ? answerValidationMessagesConstant.DATE.INVALID_2 : answerValidationMessagesConstant.DATE.INVALID
    };
};

export const checkClientValidation = (questionId, message, chats) => {
    let valid = true;
    let validationMessage = '';

    if (questionId === CONSTANT.CHATBOT_ACCOUNT.PASSWORD) {
        if (message.length > 7 && /[a-z]/.test(message) && /[A-Z]/.test(message) && /[0-9]/.test(message)) {
            valid = true;
        } else {
            valid = false;
            validationMessage = answerValidationMessagesConstant.PASSWORD.TOO_SHORT;
        }
    }

    if (questionId === CONSTANT.CHATBOT_ACCOUNT.CONFIRM_PASSWORD) {
        chats = chats || [];
        const index = chats.findIndex(item => item.questionId === CONSTANT.CHATBOT_ACCOUNT.PASSWORD);

        if (index > -1) {
            const tempChat = chats[index];
            const password = tempChat.answers && tempChat.answers[0].name;

            if (password !== message) {
                valid = false;
                validationMessage = answerValidationMessagesConstant.CONFIRM_PASSWORD.MISMATCH;
            }
        }
    }

    if (questionId === CONSTANT.CHATBOT_ACCOUNT.EMAIL) {
        // eslint-disable-next-line
        const regExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        if (!regExp.test(message)) {
            valid = false;
            validationMessage = answerValidationMessagesConstant.EMAIL.INVALID;
        }
    }

    if (questionId === CONSTANT.CHATBOT_ACCOUNT.HEIGHT) {
        const height = +message;

        if (isNaN(message)) {
            valid = false;
            validationMessage = answerValidationMessagesConstant.HEIGHT.INVALID;

        } else if (Number(height) === height && height % 1 !== 0) {
            valid = false;
            validationMessage = answerValidationMessagesConstant.HEIGHT.NOT_INTEGER
        } else if (height < 12 || height > 107) {
            valid = false;
            validationMessage = answerValidationMessagesConstant.HEIGHT.OUT_OF_RANGE;
        }
    }

    if (questionId === CONSTANT.CHATBOT_ACCOUNT.WEIGHT) {
        const weight = +message;

        if (isNaN(message)) {
            valid = false;
            validationMessage = answerValidationMessagesConstant.WEIGHT.INVALID;

        } else if (Number(weight) === weight && weight % 1 !== 0) {
            valid = false;
            validationMessage = answerValidationMessagesConstant.WEIGHT.NOT_INTEGER;
        } else if (weight < 50 || weight > 500) {
            valid = false;
            validationMessage = answerValidationMessagesConstant.WEIGHT.OUT_OF_RANGE;
        }
    }

    if (questionId === CONSTANT.CHATBOT_ACCOUNT.DATE_OF_BIRTH) {
        // noinspection JSUnresolvedFunction

        const isDateValid = dateValidator(message);
        valid = isDateValid.valid;
        validationMessage = isDateValid.message;
        const age = calculateAge(message);

        if (valid) {
            if (age < 13 || age > 120) {
                valid = false;
                validationMessage = answerValidationMessagesConstant.DATE_OF_BIRTH.AGE_RANGE;
            }
        }
    }

    if (questionId === CONSTANT.CHATBOT_ACCOUNT.NEXT_KEY_EVENT_DATE) {
        const isDateValid = dateValidator(message);
        valid = isDateValid.valid;
        validationMessage = isDateValid.message;

        if (valid) {
            // Parse the date and check if it's today or in the future
            const userDate = message.split('/');
            const formatedDate = new Date(`${userDate[2]}-${userDate[0]}-${userDate[1]}`);
            const today = new Date();

            formatedDate.setHours(0, 0, 0, 0);
            today.setHours(0, 0, 0, 0);

            if (formatedDate < today) {
                valid = false;
                validationMessage = answerValidationMessagesConstant.NEXT_KEY_EVENT_DATE.OUT_OF_RANGE;
            }
        }
    }

    // if(questionId === CONSTANT.CHATBOT_ACCOUNT.ACCIDENT_DIRECT_TRAUMA) {
    //     const isDateValid = dateValidator(message);
    //     valid = isDateValid.valid;
    //     validationMessage = isDateValid.message;
    //
    //     if(valid && !dateInPast(message)) {
    //         valid = false;
    //         validationMessage = 'Date must be in past';
    //     }
    // }

    return { valid: valid, message: validationMessage };
}

export const clearUrlParams = () => {
    GLOBAL.URL_PARAMS.IS_INTAKE_SIGNED = false;
    GLOBAL.URL_PARAMS.REDIRECT_TYPE = '';
    GLOBAL.URL_PARAMS.INVITATION_ID = '';
    GLOBAL.URL_PARAMS.BODY_REGION_LIST = [];
    GLOBAL.URL_PARAMS.EMAIL_ADDRESS = '';
    GLOBAL.URL_PARAMS.AUTO_LOGIN = false;
    GLOBAL.URL_PARAMS.PATIENT_ID = '';
    GLOBAL.URL_PARAMS.ROLE = 2;
};

export const getCurrentYear = () => {
    return new Date().getFullYear();
};

const getAutoCompleteOptions = (responses) => {
    return responses.map(item => {
        item['value'] = item['id'];
        item['label'] = item['name'];
        return item;
    });
};

export const loadOptions = (allOptions) => async (search, prevOptions) => {
    let options = getAutoCompleteOptions(allOptions);
    let filteredOptions;

    if (!search) {
        filteredOptions = options;
    } else {
        const searchLower = search.toLowerCase();

        filteredOptions = options.filter(({ label }) =>
            label.toLowerCase().includes(searchLower)
        );
    }

    const hasMore = filteredOptions.length > prevOptions.length + 10;
    const slicedOptions = filteredOptions.slice(
        prevOptions.length,
        prevOptions.length + 10
    );

    return {
        options: slicedOptions,
        hasMore
    };
};

export const deepClone = (obj) => {
    if (obj === null || typeof obj !== 'object') {
        return obj;
    }

    if (Array.isArray(obj)) {
        const arrCopy = [];
        obj.forEach((item, index) => {
            arrCopy[index] = deepClone(item);
        });
        return arrCopy;
    }

    const objCopy = {};
    Object.keys(obj).forEach(key => {
        objCopy[key] = deepClone(obj[key]);
    });
    return objCopy;
};

// export const deepClone = (obj, seen = new WeakMap()) => {
//     // Handle null, undefined, and primitive types
//     if (obj === null || typeof obj !== 'object') {
//         return obj;
//     }
//
//     // Handle circular references
//     if (seen.has(obj)) {
//         return seen.get(obj);
//     }
//
//     // Handle Date objects
//     if (obj instanceof Date) {
//         return new Date(obj.getTime());
//     }
//
//     // Handle Array objects
//     if (Array.isArray(obj)) {
//         const arrCopy = [];
//         seen.set(obj, arrCopy);
//         obj.forEach((item, index) => {
//             arrCopy[index] = deepClone(item, seen);
//         });
//         return arrCopy;
//     }
//
//     // Handle Maps
//     if (obj instanceof Map) {
//         const mapCopy = new Map();
//         seen.set(obj, mapCopy);
//         obj.forEach((value, key) => {
//             mapCopy.set(key, deepClone(value, seen));
//         });
//         return mapCopy;
//     }
//
//     // Handle Sets
//     if (obj instanceof Set) {
//         const setCopy = new Set();
//         seen.set(obj, setCopy);
//         obj.forEach(value => {
//             setCopy.add(deepClone(value, seen));
//         });
//         return setCopy;
//     }
//
//     // Handle regular objects
//     const objCopy = Object.create(Object.getPrototypeOf(obj)); // Maintain prototype
//     seen.set(obj, objCopy);
//
//     // Handle non-enumerable properties if needed
//     Object.getOwnPropertyNames(obj).forEach(key => {
//         const descriptor = Object.getOwnPropertyDescriptor(obj, key);
//         if (descriptor && descriptor.value !== undefined) {
//             descriptor.value = deepClone(descriptor.value, seen);
//         }
//         Object.defineProperty(objCopy, key, descriptor);
//     });
//
//     return objCopy;
// };

export const downloadReportOnCurrentTab = async (url) => {
    try {
        // Fetch the PDF from the external URL
        const response = await fetch(url);

        // Check if the request was successful
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        // Convert response to blob
        const blob = await response.blob();

        // Create a blob URL (same-origin)
        const blobUrl = window.URL.createObjectURL(blob);

        // Extract filename from URL
        const filename = url.substring(url.lastIndexOf('/') + 1).split('?')[0]; // Remove query params

        // Create anchor element and trigger download
        const anchorTagOfDownloadReport = document.createElement('a');
        anchorTagOfDownloadReport.href = blobUrl;
        anchorTagOfDownloadReport.download = filename;
        document.body.appendChild(anchorTagOfDownloadReport);
        anchorTagOfDownloadReport.click();

        // Clean up
        document.body.removeChild(anchorTagOfDownloadReport);

        // Revoke blob URL to free up memory
        window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
        console.error('Error downloading report:', error);
        // Fallback: open in new tab if download fails
        window.open(url, '_blank');
    }
};

export const getPatientPortalType = (tenantFeatures) => {
    let patientPortalType = '';
    tenantFeatures?.length > 0 && tenantFeatures.forEach((tenantItem) => {
        if (tenantItem['IsEnabledForPatient']) {
            if (tenantItem.Name === 'PatientPortalType') {
                patientPortalType = tenantItem.Value;
            }
        }
    });

    return patientPortalType;
};

export const prepareEnabledSubscribedFeatures = (features) => {
    const arrayOfFeatureEnable = Object.entries(CONSTANT.FEATURE_ENABLE);
    let permissions = {}

    for (const [key] of arrayOfFeatureEnable) {
        for (let i = 0; i < features.length; i++) {
            if (key === features[i].Name) {
                permissions = {
                    ...permissions,
                    [key]: features[i]['IsEnabled'] && CONSTANT.FEATURE_ENABLE[key]
                }
            }
        }
    }

    // permissions['EnableFysicalScore'] = true;
    // permissions['IsPostureAnalyzeEnabled'] = true;

    return permissions;
};

export const _getWaitingRoomByInvitationInfo = async (testId, invId) => {
    const payload = {
        TestId: testId,
        InvitationId: invId
    };

    const response = await examService.getWaitingRoomByInvitation(payload);
    const { success, data, error } = response;

    if (!success) {
        console.error(error);
    }

    const invitationInfo = (data && Object.keys(data)?.length > 0) && (data || '{}');
    return {
        meetingRoomUrl: invitationInfo?.['MeetingRoomUrl'] || '',
        invitationId: invitationInfo?.['InvitationId'] || '',
        isMeetingInFutureDate: invitationInfo?.['IsMeetingInFutureDate'] || false,
        waitingRoomId: invitationInfo?.['WaitingRoomId'] || ''
    }
}

export const getArrayFromObject = (object) => {
    let array = [];
    if (Object.keys(object).length > 0) {
        for (const [, value] of Object.entries(object)) {
            array.push(value);
        }
        return array;
    }
    return array;
}

export const getBodyRegionNames = (bodyRegionList) => {
    let bodyRegionName = '';

    if (bodyRegionList && bodyRegionList.length > 0) {
        for (const [, value] of Object.entries(CONSTANT.BODY_REGIONS)) {
            if (bodyRegionList.includes(value.key)) {
                if (!bodyRegionName) {
                    bodyRegionName = value.name;
                } else {
                    bodyRegionName += ',' + value.name;
                }
            }
        }
    }

    return bodyRegionName;
}

export const getAudioUrl = (key) => {
    console.log('inside getAudioUrl')
    let generalAudioURL = '';
    const generalAudio = (GLOBAL.GENERAL_AUDIOS).find((audio) => audio['KeyText'] === key);

    if (generalAudio) {
        generalAudioURL = generalAudio['AudioUrl'];
    }

    return generalAudioURL;
}

export const convertRecordedChunksToBase64 = async (recordedChunks) => {
    const chunks = recordedChunks || [];
    const blob = new Blob(chunks, { 'type': CONSTANT.VIDEO_TYPE.VIDEO_MP4 });
    // noinspection JSUnusedAssignment
    let base64data = 'noise';
    base64data = await convertToBase64(blob);

    return base64data;
}

export const storeRecordedVideo = async (patientId, aiType, base64data, selectedMovement, filename) => {//ROM API
    const storePayload = {
        patientId: patientId,//ROM API
        exerciseName: aiType,
        filename: filename,
        blobBase64: base64data
    };

    const response = await exerciseService.storeRecordedVideo(storePayload);
    if (!response.success) {
        console.error('storeRecordedVideo:', response.error);
    }

    return response;
}

export const _convertHourMinFromMin = (value) => {
    let finalValue;
    const hour = Math.floor(value / 60);
    const min = value % 60;
    if (hour > 0) {
        finalValue = `${hour}.${min}${hour > 1 || min > 0 ? ' hours' : ' hour'}`;
    } else {
        finalValue = min + ' min';
    }

    return finalValue;
}

export const _getHourMinValuesOptionsMinValues = (values) => {
    const finalValues = values?.map((item) => _convertHourMinFromMin(item));
    return finalValues?.map((item, index) => {
        return {
            value: values[index],
            label: item
        }
    });
}

export const downloadFile = (url) => {
    const link = document.createElement('a');
    link.href = url;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}

export const getBodyRegionsValueLabelObjectArray = () => {
    const bodyRegions = getArrayFromObject(CONSTANT.BODY_REGIONS);
    const options = bodyRegions?.map((item) => {
        return {
            value: item.key,
            label: item.name
        }
    });

    return options;
}

export const getSportsTypeValueLabelObjectArray = () => {
    const sportsType = getArrayFromObject(CONSTANT.SPORTS_TYPE);
    const options = sportsType?.map((item) => {
        return {
            value: item.key,
            label: item.name
        }
    });

    return options;
}

// export const storeInvitationInfoInGlobalVariable = (inv, patientId, referType = "refer") => {
//     GLOBAL.URL_PARAMS.IS_INTAKE_SIGNED = inv["IsIntakeSigned"];
//     GLOBAL.URL_PARAMS.PATIENT_ID = patientId;
//     GLOBAL.URL_PARAMS.REDIRECT_TYPE = referType;
//     GLOBAL.URL_PARAMS.INVITATION_ID = inv.InvitationId;
//     GLOBAL.URL_PARAMS.BODY_REGION_LIST = inv.BodyRegionList;
//     GLOBAL.URL_PARAMS.EMAIL_ADDRESS = inv.EmailAddress;
//     GLOBAL.URL_PARAMS.REFER_TYPE = inv["RedirectTypeText"];
//     GLOBAL.URL_PARAMS.IS_FOLLOWUP = inv["IsFollowup"];
//     GLOBAL.URL_PARAMS.TEST_ID = inv.TestId;
// }

export const isEmptyObject = (obj) => {
    if (!obj) return true;

    return Object.keys(obj).length === 0 && obj.constructor === Object;
}

export const storeUserInfoToLocalStorageFromGlobalConstant = () => {
    localStorage.removeItem("userInfo");
    localStorage.setItem("userInfo", JSON.stringify(GLOBAL.USER_INFO));
}

export function convertRgbToRgba(rgbString, alpha = 0.2) {
    try {
        // Extract the RGB values from the string using a regular expression
        const rgbValues = rgbString.match(/(\d+), (\d+), (\d+)/);

        if (!rgbValues) {
            console.error(rgbString)
            throw new Error('Invalid RGB string provided.');
        }

        // Construct the RGBA string using the extracted RGB values and the provided alpha value
        const rgbaString = `rgb(${rgbValues[1]}, ${rgbValues[2]}, ${rgbValues[3]}, ${alpha})`;

        return rgbaString;
    }
    catch (e) {
        throw new Error(`An error occurred while converting the RGB string to an RGBA string: ${e.message}`);
    }
}

export function makeSerializable(obj) {
    return JSON.parse(JSON.stringify(obj));
}

export const getAssessmentCompletion = (responseData) => {
    let groups = [];
    for (const [, value] of Object.entries(CONSTANT.ASSESSMENT_GROUP)) {
        let tempGroup = {};
        if (value.key !== CONSTANT.ASSESSMENT_GROUP.OUTCOME_ASSESSMENT.key) {
            let isCurrentGroupCompleted = false;
            if (value.key === CONSTANT.ASSESSMENT_GROUP.DEMOGRAPHICS.key) {
                isCurrentGroupCompleted = responseData?.["DemographicsCompleted"] || false
            } else if (value.key === CONSTANT.ASSESSMENT_GROUP.ATHLETE.key) {
                isCurrentGroupCompleted = responseData?.["AthleteCompleted"] || false
            } else if (value.key === CONSTANT.ASSESSMENT_GROUP.ADL.key) {
                isCurrentGroupCompleted = responseData?.["ADLCompleted"] || false
            } else if (value.key === CONSTANT.ASSESSMENT_GROUP.MEDICAL_HISTORY.key) {
                isCurrentGroupCompleted = responseData?.["MedicalHistoryCompleted"] || false
            } else if (value.key === CONSTANT.ASSESSMENT_GROUP.BIOMETRIC.key) {
                isCurrentGroupCompleted = responseData?.["BiometricCompleted"] || false
            } else if (value.key === CONSTANT.ASSESSMENT_GROUP.CHIEF_COMPLAINTS.key) {
                isCurrentGroupCompleted = responseData?.["ChiefComplaintsCompleted"] || false
            }

            tempGroup = {
                ...value,
                groupCompleted: isCurrentGroupCompleted
            }
            groups.push(tempGroup);
        }
    }

    return groups;
}

export const shouldCheckboxOptionDisabled = (singleSelectAnswerId, answerList, answerId) => {
    if (singleSelectAnswerId) {
        if (answerList.length > 0) {
            if (answerList.includes(singleSelectAnswerId) && answerId !== singleSelectAnswerId) {
                return true;
            } else if (!answerList.includes(singleSelectAnswerId) && answerId === singleSelectAnswerId) {
                return true;
            }
        }
    }
    return false;
}

export const truncateTime = (date) => {
    // Remove the seconds and milliseconds, ensuring it remains in UTC
    date.setUTCSeconds(0, 0);
    return date;
}

export const ensureUTC = (dateString) => {
    // Enforce a standardized UTC format, ensuring compatibility across browsers
    if (!dateString.toLowerCase().endsWith('z')) {
        return dateString + 'Z';
    }
    return dateString;
}

export function formatDateTimeIntoISO8601(dateStr, timeStr) {
    // Combine date and time strings
    const dateTimeStr = `${dateStr} ${timeStr}`;

    // Parse the combined string into a Date object
    const months = {
        "January": 0, "February": 1, "March": 2, "April": 3, "May": 4, "June": 5,
        "July": 6, "August": 7, "September": 8, "October": 9, "November": 10, "December": 11
    };
    const parts = dateTimeStr.match(/(\w+) (\d+), (\d+) (\d+):(\d+) ([AP]M)/);
    const year = parseInt(parts[3], 10);
    const month = months[parts[1]];
    const day = parseInt(parts[2], 10);
    let hours = parseInt(parts[4], 10) + (parts[6] === "PM" && parts[4] !== "12" ? 12 : 0);
    if (parts[6] === "AM" && parts[4] === "12") hours = 0; // Convert 12 AM to 00
    const minutes = parseInt(parts[5], 10);

    // Create a Date object
    const date = new Date(year, month, day, hours, minutes);

    // Format to YYYY-MM-DDTHH:MM:SS
    const pad = (num) => num.toString().padStart(2, '0');
    const formattedDate = `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;

    return formattedDate;
}

export function formatDateToMMDDYYYY(dateInput) {
    if (typeof dateInput !== 'string' || dateInput === "") {
        console.error("Invalid date input:", dateInput);
        return "";
    }


    // Directly return input if it contains underscores or matches the placeholder format
    const containsUnderscore = /_/.test(dateInput);
    if (dateInput === "" || containsUnderscore) {
        console.info("Input contains underscores or matches placeholder format, returning as is:", dateInput);
        return dateInput;
    }

    let date;
    try {
        // For ISO 8601 format strings like "YYYY-MM-DDTHH:MM:SSZ", "2024-11-21T14:35:22", "2024-11-21"
        // Also for formats like "MM/DD/YYYY HH:MM:SS", "MM/DD/YYYY", "MM/DD/YYYY HH:MM", "MM/DD/YYYY HH:MM:SS AM/PM"
        // As well as "MM/DD/YYYY HH:MM AM/PM" and "MM/DD/YYYY HH AM/PM" as those are not ISO 8601
        date = new Date(dateInput);

        // If date parsing fails (invalid date like "19/12/1999"), `date` will be invalid.
        if (isNaN(date)) {
            console.error("Invalid date format, returning input as is:", dateInput);
            return dateInput; // Return the original input if invalid
        }
    } catch (e) {
        //will throw error for invalid date like 13/12/1990 in that case will return like that as it will show error in
        //ui while user try to move another tab
        console.error("Error parsing date:", e);
        return dateInput;
    }

    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const year = date.getFullYear();

    const formattedDate = `${month}/${day}/${year}`;
    return formattedDate;
}

export function formatDateAsMonthStrDayYear(inputDate) {
    const date = new Date(inputDate);

    // Check if the date is valid
    if (isNaN(date.getTime())) {
        return "Invalid Date";
    }

    const monthNames = [
        "Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
    ];

    const day = date.getDate();
    const month = monthNames[date.getMonth()];
    const year = date.getFullYear();

    return `${month} ${day}, ${year}`;
}

export const convertBodyRegionStrIntoBodyRegionListArrayOfNumber = (bodyRegionStr) => {
    try {
        const bodyRegionList = bodyRegionStr.split(',').map(Number) || [];
        return bodyRegionList;
    } catch (e) {
        console.error(e);
        return [];
    }
}

export function getRedirectType(invitationTypeId) {
    switch (invitationTypeId) {
        case CONSTANT.INVITATION_TYPE.Self:
            return CONSTANT.REDIRECT_TYPE.SELF;
        case CONSTANT.INVITATION_TYPE.Telemedicine:
            return CONSTANT.REDIRECT_TYPE.TELEMEDICINE;
        case CONSTANT.INVITATION_TYPE.InClinic:
            return CONSTANT.REDIRECT_TYPE.INCLINIC;
        default:
            return CONSTANT.REDIRECT_TYPE.REFER;
    }
}

export function isMobileDevice() {
    if (typeof navigator === "undefined") return false;

    const ua = navigator.userAgent.toLowerCase();

    // iPadOS detection (Safari reports as Mac)
    const isIpad =
        navigator.platform === "MacIntel" &&
        navigator.maxTouchPoints > 1;

    // Tablet detection
    const isTablet =
        isIpad ||
        /tablet|kindle|silk/.test(ua) ||
        (/android/.test(ua) && !/mobile/.test(ua));

    // Mobile phone detection
    const isMobile =
        /android|iphone|ipod|blackberry|iemobile|opera mini/.test(ua);

    return isMobile || isTablet || window.innerWidth < 768;
}

export async function generateQRCode(url) {
    // Generate the QR code as a base64 types URL
    const qrCodeDataUrl = await QRCode.toDataURL(url);

    return qrCodeDataUrl;
}

// Levenshtein distance function to find difference between two strings
const levenshtein = (a, b) => {
    const matrix = Array.from({ length: b.length + 1 }, (_, i) => [i]);
    matrix[0] = Array.from({ length: a.length + 1 }, (_, j) => j);
    for (let i = 1; i <= b.length; i++) {
        for (let j = 1; j <= a.length; j++) {
            matrix[i][j] =
                b[i - 1] === a[j - 1]
                    ? matrix[i - 1][j - 1]
                    : Math.min(
                        matrix[i - 1][j - 1] + 1, // substitution
                        matrix[i][j - 1] + 1,     // insertion
                        matrix[i - 1][j] + 1      // deletion
                    );
        }
    }
    return matrix[b.length][a.length];
};

// Similarity score between 0 and 1
export const similarity = (a, b) => {
    if (!a || !b) return 0;
    const distance = levenshtein(a, b);
    return 1 - distance / Math.max(a.length, b.length);
};

/**
 * Looks up a single item directly in the top-level RealTimeDetection array by its KeyText.
 * Unlike getMessageByKeyTexts, this does NOT use a category/subcategory nesting.
 */
export const getMessageByKeyText = (realTimeDetectionConstrains, keyText) => {
    if (!realTimeDetectionConstrains?.RealTimeDetection) return null;

    for (const group of realTimeDetectionConstrains.RealTimeDetection) {
        const item = group.RealTimeDetectionList?.find(
            (i) => i.KeyText === keyText
        );

        if (item) {
            return {
                message: item.UiMessage || item.Instruction || "",
                audio: item.AudioUrl || "",
            };
        }
    }

    return null;
};

export const getMessageByKeyTexts = (realTimeDetectionConstrains, categoryKeyText, messageKeyText) => {
    if (!realTimeDetectionConstrains) return null;
    const category = realTimeDetectionConstrains.RealTimeDetection?.find(
        (item) => item.KeyText === categoryKeyText
    );

    if (!category) return null;

    const message = category.RealTimeDetectionList?.find(
        (item) => item.KeyText === messageKeyText
    );

    return {
        message: message?.UiMessage || "",
        audio: message?.AudioUrl || "",
    };
};